import client from "./client";

export async function fetchProfile({ signal } = {}) {
  const response = await client.get("/api/v1/profile/me", { signal });
  return response.data;
}

export async function updateProfile(payload, { signal } = {}) {
  const response = await client.patch("/api/v1/profile/me", payload, { signal });
  return response.data;
}

export async function changePassword({ current_password, new_password }) {
  const response = await client.post("/api/v1/profile/me/change-password", {
    current_password,
    new_password,
  });
  return response.data;
}

export async function deleteAccount() {
  const response = await client.delete("/api/v1/profile/me");
  return response.data;
}

// Admin: user / role management.
export async function listUsers({ limit = 200, offset = 0 } = {}) {
  const response = await client.get("/api/v1/profile/users", { params: { limit, offset } });
  return response.data;
}

export async function setUserRole(userId, role) {
  const response = await client.patch(`/api/v1/profile/users/${userId}/role`, { role });
  return response.data;
}
